import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

const SIGN_FRAME_ID = "welcome_sign_content"

export default class extends Controller {
  static values = {
    defaultUrl: String,
    menuUrl: String,
  }

  connect() {
    this.boundOnFrameLoad = this.onSignFrameLoaded.bind(this)
    document.addEventListener("turbo:frame-load", this.boundOnFrameLoad)
    // After other controllers (e.g. menu-toggle) connect on this page.
    queueMicrotask(() => this.broadcastSignNav())
  }

  disconnect() {
    document.removeEventListener("turbo:frame-load", this.boundOnFrameLoad)
  }

  /** Turbo dispatches this on the `<turbo-frame>` when a visit targeting it finishes. */
  onSignFrameLoaded(event) {
    if (event.target?.id !== SIGN_FRAME_ID) return
    this.broadcastSignNav()
  }

  /** Lets `menu-toggle` match chrome to inner `data-welcome-section` (see `_sign_content_frame`). */
  broadcastSignNav() {
    const frame = document.getElementById(SIGN_FRAME_ID)
    if (!frame) return
    const marker = frame.querySelector("[data-welcome-section]")
    const section = marker?.dataset?.welcomeSection
    if (!section) return
    window.dispatchEvent(
      new CustomEvent("signNav:sync", {
        bubbles: true,
        detail: { section },
      }),
    )
  }

  handleMenuOpen() {
    if (this.hasMenuUrlValue) {
      Turbo.visit(this.menuUrlValue, { frame: SIGN_FRAME_ID })
      return
    }

    if (this.hasDefaultUrlValue) {
      Turbo.visit(this.defaultUrlValue, { frame: SIGN_FRAME_ID })
    }
  }

  resetToDefault() {
    if (this.hasDefaultUrlValue) {
      Turbo.visit(this.defaultUrlValue, { frame: SIGN_FRAME_ID })
    }
  }
}
